<template>
  <div class="ts-menu-group">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.ts-menu-group {
  font-family: Roboto;
  font-size: 16px;
  color: #9aa5b7;
  padding: 0 8px;
  margin: 16px 0 8px 0;
}
</style>

<script>
export default {
  name: 'TsMenuGroup'
};
</script>
